export default {
  errors: {
    messages: {
      empty:    '%(key)s is required',
      email:    '%(key)s is not a valid email address',
      min:      '%(key)s must be at least %(limit)s characters',
      regex:    '%(key)s is invalid',
      required: '%(key)s is required'
    },
    schemas: {
    }
  },
  labels: {
    doctor: {
      currentStartDate: 'Start Date',
      email: 'Email',
      name: 'Name'
    },
    manager: {
      name: 'Your Name',
      office: {
        address:     'Address',
        city:        'City',
        name:        'Office Name',
        state:       'State',
        phoneNumber: 'Phone Number',
        postalCode:  'Zip Code'
      },
      user: {
        email:    'Email',
        password: 'Password'
      }
    },
    passwordReset: {
      passwordConfirmation: 'Password Confirmation'
    },
    rep: {
      company:     'Company',
      name:        'Name',
      phoneNumber: 'Phone Number',
      products:    'Products',
      specialty:   'Specialty',
      user: {
        email:    'Email',
        password: 'Password'
      }
    }
  }
};



// WEBPACK FOOTER //
// ./app/config/locales/en.js